<!-- News Item -->
<div class="container">
    <div class="row">
        <div class="col-md-6">
            <h2 style="background-color: white;">News Stories</h2>
        </div>
        <div class="col-md-6">
            <div class="input-group mt-4">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
                </div>
                <!-- <input type="text" class="form-control" placeholder="Search" [(ngModel)]="strSearch" aria-label="search" name="search" aria-describedby="basic-addon1" (keyup.enter)="filter()"> -->
            </div>
        </div>
    </div>
    <div class="card mb-3" *ngFor="let n of news">
        <div class="card-body" style="cursor: pointer;">
            <div class="row" (click)="navigate(n.payload.doc.data().link)">
            <div class="col-md-4">
                <img *ngIf="n.payload.doc.data().imageUrl != null" class="img-fluid mt-3" style="max-height: 250px;" [src]="n.payload.doc.data().imageUrl">   
                <img *ngIf="n.payload.doc.data().imageUrl == null" class="img-fluid mt-3" style="max-height: 250px;" src="https://regscaleblob.blob.core.windows.net/blob/news.png">   
              </div>
              <div class="col-md-8">
                  <table style="border: 0px;">
                      <tr>
                          <td style="height: 200px;">
                            <h3 style="margin-top: 0px; margin-bottom: 0px; font-weight: bold; color: #F26523;">{{ n.payload.doc.data().title }}</h3><br/>
                        </td>
                      </tr>
                      <tr>
                        <td style="height: 50px;">
                            <img src="https://regscaleblob.blob.core.windows.net/blob/karmel.jpg" class="rounded-circle" style="max-height: 50px; padding-bottom: 0px; padding-top: 0px;" alt="author image" /> Anil Karmel <span class="float-right mt-3" style="font-style: italic;"><i class="far fa-calendar" style="color: #F26523"></i> {{ n.payload.doc.data().datePublished |  date:'fullDate' }}</span>
                        </td>
                    </tr>
                  </table>
              </div>
            </div>
        </div>
      </div>
<br><br>
</div>
    


